/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthGalleryCreateDto } from '../../models/growth-gallery-create-dto';
import { GrowthGalleryDto } from '../../models/growth-gallery-dto';

export interface GrowthGalleryControllerCreate$Params {
      body: GrowthGalleryCreateDto
}

export function growthGalleryControllerCreate(http: HttpClient, rootUrl: string, params: GrowthGalleryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
  const rb = new RequestBuilder(rootUrl, growthGalleryControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthGalleryDto>;
    })
  );
}

growthGalleryControllerCreate.PATH = '/api/growth-galleries';
